module.exports = __webpack_public_path__ + "static/media/text.5d3955f8.png";